import styled from 'styled-components';

export const Note = styled.div<{ $dragging: boolean; $color: string }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  min-width: 130px;
  min-height: 60px;
  max-width: 250px;
  padding: 11px 30px 12px 14px;
  cursor: ${({ $dragging }) => ($dragging ? 'grabbing' : 'grab')};
  user-select: none;
  border: 1.5px solid transparent;
  border-radius: 8px;
  color: ${({ $color }) => $color};
  transition: ${({ $dragging }) =>
    $dragging ? 'none' : 'border-color .15s,background .15s,box-shadow .15s'};

  ${({ $dragging }) =>
    $dragging
      ? `
        border-color: rgba(255,255,255,.4);
        background: rgba(255,255,255,.06);
        box-shadow: 0 14px 34px rgba(0,0,0,.55);
      `
      : `
        &:hover {
          border-color: rgba(255,255,255,.22);
          background: rgba(255,255,255,.04);
        }
      `}
`;

export const CnText = styled.div`
  font-family: var(--hand);
  font-size: 25px;
  font-weight: 500;
  line-height: 1.18;
  white-space: pre-wrap;
  word-break: break-word;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.1);
  cursor: text;
  user-select: text;
  outline: none;
  border-radius: 4px;
  min-width: 90px;
  flex: 1;
  min-height: 0;

  &:focus {
    outline: 1px solid rgba(255, 255, 255, 0.5);
    outline-offset: 3px;
    background: rgba(255, 255, 255, 0.05);
  }

  &:empty::before {
    content: 'Tippt eure Notiz …';
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const CnResizeHandle = styled.span`
  position: absolute;
  right: 2px;
  bottom: 1px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  cursor: nwse-resize;
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
  line-height: 1;
  user-select: none;

  &:hover {
    color: rgba(255, 255, 255, 0.65);
  }
`;

export const CnResizeHandleHorizontal = styled.span`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 12px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ew-resize;
  user-select: none;

  &::before {
    content: '';
    width: 4px;
    height: 20px;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  &:hover::before {
    border-color: rgba(255, 255, 255, 0.65);
  }
`;

export const CnDel = styled.button`
  position: absolute;
  top: 5px;
  right: 6px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 2px 5px;
  border-radius: 5px;
  transition: all 0.15s;

  &:hover {
    background: rgba(255, 80, 80, 0.25);
    color: #ffb0b0;
  }
`;

export const CnToolbar = styled.div<{ $visible: boolean }>`
  position: absolute;
  top: -40px;
  left: 0;
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  gap: 4px;
  background: #0d1714;
  border: 1px solid #2a3a32;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.5);
  z-index: 300;
`;

export const CnToolbarBtn = styled.button<{
  $active?: boolean;
  $variant: 'b' | 'i' | 'u' | 'c';
}>`
  width: 30px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  background: ${({ $active }) =>
    $active ? '#FF7A10' : 'rgba(255,255,255,.08)'};
  color: ${({ $active }) => ($active ? '#fff' : '#e8e0d0')};
  cursor: pointer;
  font-family: Georgia, serif;
  font-size: 15px;
  ${({ $active }) =>
    $active && 'box-shadow: inset 0 0 0 1px rgba(255,255,255,.3);'}
  ${({ $variant }) => $variant === 'b' && 'font-weight: 800;'}
  ${({ $variant }) => $variant === 'i' && 'font-style: italic;'}
  ${({ $variant }) => $variant === 'u' && 'text-decoration: underline;'}

  &:hover {
    background: ${({ $active }) =>
      $active ? '#ff8a2a' : 'rgba(255,255,255,.2)'};
  }
`;

export const CnToolbarSwatch = styled.span<{ $swatch: string }>`
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${({ $swatch }) => $swatch};
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
`;
